import React from 'react';
import {Button, Dialog, DialogActions, DialogContent} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {ShiftData} from '@/components/shifts';
import ShiftItem from '@/components/shifts/ShiftItem';
import {useIsMobile} from "@/hooks/use-mobile.tsx";

interface DetailDialogProps {
  shift: ShiftData | null;
  open: boolean;
  onClose: () => void;
}

const ShiftDetailDialog = ({ shift, open, onClose }: DetailDialogProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (!shift) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isMobile}>
      <DialogContent sx={{ bgcolor: 'background.paper', pt: 2 }}>
        <ShiftItem shift={shift} />
      </DialogContent>
      <DialogActions sx={{ bgcolor: 'background.paper' }}>
        <Button onClick={onClose} color="primary">
          {t('events.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShiftDetailDialog;
